import React, { forwardRef } from 'react';

import { Stack, Typography } from '@mui/material';

import ScheduleContentBannerImageInput, { getBannerId } from './Inputs/ScheduleContentBannerImageInput';

interface Props {
  defaultEmailBannerInitial: string;
  brand: string;
}

enum SCHEDULE_BANNER_INPUT_NAMES {
  // Rmoved banner after 1st deal
  BANNER_IMAGE_ID_POS_5 = 'schedule_banner_image_id_pos_5', // Default Banner (after 4th deal)
}

export function parseScheduleBannerFormData(
  formData: FormData,
): Pick<CustomerCommunication.UnsavedHeroPlannerSchedule, 'emailBannerId' | 'emailBannerPosition2Id'> {
  return {
    emailBannerId: getBannerId(String(formData.get(SCHEDULE_BANNER_INPUT_NAMES.BANNER_IMAGE_ID_POS_5))),
    emailBannerPosition2Id: undefined,
  };
}

const ScheduleBannerForm = forwardRef<HTMLFormElement, Props>((props, ref) => {
  const { defaultEmailBannerInitial, brand } = props;
  return (
    <Stack component="form" ref={ref} direction="column" gap={8}>
      <Stack direction="column" gap={2}>
        <Typography variant="h5">Default Banner (after 4th deal)</Typography>

        <ScheduleContentBannerImageInput
          name={SCHEDULE_BANNER_INPUT_NAMES.BANNER_IMAGE_ID_POS_5}
          initialBannerId={defaultEmailBannerInitial}
          label="Default Banner (after 4th deal)"
          brand={brand}
        />
      </Stack>
    </Stack>
  );
});

ScheduleBannerForm.displayName = 'ScheduleBannerForm';

export default ScheduleBannerForm;
